<template>
  <main-content-layout
    :title="$gettext('UNIT_ADDRESS')"
    :buttonTitle="$gettext('INCLUDE')"
    :actionButton="
      () => {
        showInclude();
      }
    "
    buttonIconName="list"
  >
    <div class="row">
      <address-unit-card
        v-for="address in addressUnitData"
        :key="address.id"
        :data="address"
        @edit="edit"
        @open-map="openMap"
      />
      <consumer-unit-address
      v-if="consumerUnitAddressShow"
      ref="consumerUnitAddressModal"
      :form="forms"
      @save-address="onSave"
      @onAddSuccess="onAddConsumerUnitAddressSuccessHandler"
      @onEditSuccess="onEditConsumerUnitAddressSuccessHandler"
    />
    </div>
    <map-modal @close-modal="closeMapModal"  v-if="renderMap" :latitude="mapLatitude"
     :longitude="mapLongitude" :renderMap="renderMap" ref="mapModal" />
  </main-content-layout>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequesAddressUnitController from './ServiceRequesAddressUnitController'
import AddressUnitCard from './AddressUnitCard.vue'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import MainContentLayout from '../../Layout/MainContentLayout.vue'
import ConsumerUnitAddress from '../../../../../consumer-unit/ConsumerUnitAddress.vue'
import MapModal from '../../../../../consumer-unit/MapModal.vue'
const { modal, page } = JtCrud

@Component({
  mixins: [page],
  name: 'ServiceRequestClientCard',
  components: {
    AddressUnitCard,
    modal,
    MainContentLayout,
    ConsumerUnitAddress,
    MapModal
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ServiceRequestClientCard extends Vue {
  AddressUnitController = ServiceRequesAddressUnitController.getInstance();
  addressUnitData = {};
  renderModal = false;
  renderMap = false;
  forms = null;
  mapLatitude = '';
  mapLongitude = '';
  consumerUnitAddressShow = false;
  personToEdit = null;
  addressToUpdate = null;
  closeModal () {
    this.renderModal = false
  }

  closeMapModal () {
    this.renderMap = false
  }

  async edit (data) {
    this.consumerUnitAddressShow = true
    const form = await this.getFormConsumerUnitAddress(data.id)
    this.forms = form[0]
    this.$nextTick(() => {
      this.$refs.consumerUnitAddressModal.show()
    })
  }

  async onSave (formData) {
    if (formData.buttonName == 'btAlterar') {
      await this.AddressUnitController.updateAddress(formData.data)
    } else if (formData.buttonName == 'btGravar') {
      await this.AddressUnitController.createAddress({
        consumerUnit: this.consumerUnit,
        ...formData.data
      })
    }
    this.loadCards()
    this.consumerUnitAddressShow = false
  }

  async getFormConsumerUnitAddress (id) {
    return await this.AddressUnitController.loadForm({ id })
  }

  async showInclude () {
    const form = await this.getFormConsumerUnitAddress()
    this.forms = form[0]
    this.consumerUnitAddressShow = true
    this.$nextTick(() => {
      this.$refs.consumerUnitAddressModal.show()
    })
  }

  openMap (data) {
    this.mapLatitude = data.latitude
    this.mapLongitude = data.longitude
    this.renderMap = true
  }

  async loadCards () {
    const { registros } = await this.AddressUnitController.loadCards({
      id: this.consumerUnit
    })
    this.addressUnitData = registros.sort(
      (a, b) => a.addressPersonType - b.addressPersonType
    )
  }

  mounted () {
    this.loadCards()
  }
}
export default ServiceRequestClientCard
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

h6 {
  font-size: 20px;
  margin: 3px 20px;
  color: $light-d;
}

.layout {
  height: 700px;
  background-color: $off-white;
}
</style>
